/**
 * ConfirmModal Component
 * 
 * Modal moderno e elegante para confirmações e mensagens.
 * Substitui alert() e window.confirm() nativos.
 */

import { X, AlertCircle, CheckCircle, Info, AlertTriangle } from 'lucide-react'
import './ConfirmModal.css'

function ConfirmModal({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  type = 'info', // 'info', 'success', 'warning', 'danger'
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  showCancel = true,
  icon: CustomIcon = undefined
}) {
  if (!isOpen) return null

  // Ícones padrão por tipo
  const iconMap = {
    info: Info,
    success: CheckCircle,
    warning: AlertTriangle,
    danger: AlertCircle
  }

  const Icon = CustomIcon || iconMap[type] || Info

  return (
    <div className="confirm-modal-overlay" onClick={onClose}>
      <div className="confirm-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="confirm-modal-header">
          <div className="confirm-modal-icon-wrapper" data-type={type}>
            <Icon size={24} />
          </div>
          <button 
            className="confirm-modal-close" 
            onClick={onClose}
            aria-label="Fechar"
          >
            <X size={20} />
          </button>
        </div>
        
        <div className="confirm-modal-body">
          {title && (
            <h3 className="confirm-modal-title">{title}</h3>
          )}
          {message && (
            <div className="confirm-modal-message">
              {typeof message === 'string' ? (
                <p>{message}</p>
              ) : (
                message
              )}
            </div>
          )}
        </div>

        <div className="confirm-modal-footer">
          {showCancel && (
            <button
              className="confirm-modal-btn confirm-modal-btn-cancel"
              onClick={onClose}
            >
              {cancelText}
            </button>
          )}
          <button
            className={`confirm-modal-btn confirm-modal-btn-confirm confirm-modal-btn-${type}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ConfirmModal

